import React from "react";
import "./styles.scss";
import "./mobile.scss";

const Index = () => {
  let inputElement = null;

  inputElement = (
    <>
      <div className={"footer-header-main-wrapper"}>
        <div className={"container"}>
          <div className={"footer-header"}>
            <div className={"fh__copyright"}>
              {" Copyright 2024 © hope of new era. All rights reserved."}
            </div>
            <div className={"fh__solution"}>{"Solution by difynbest."}</div>
          </div>
        </div>
      </div>
    </>
  );
  return <>{inputElement}</>;
};
Index.propTypes = {};

Index.defaultProps = {};
export default Index;
